import { AppLayout } from "../shared";
import Payments from "../Admin/Payments";

const Payments_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <Payments props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default Payments_layout;
